import React from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import FormComplementaryInfo from './FormComplementaryInfo';
import useEnrollmentUpdate from '../../../../../../hooks/useEnrollmentUpdate';
import file from '../../../../../../utils/file';
import DocumentTypeKey from '../../../../../../enums/DocumentTypeKey';

const ComplementaryInfo = ({ onFinish }) => {
  const [updateEnrollment, isLoading] = useEnrollmentUpdate();

  const handleSubmit = async (values) => {
    const authorizedToGiveInstructions = await Promise.all(
      (values.authorizedToGiveInstructions || []).map(async (person) => {
        const documents = [];

        if (person.power) {
          const base64 = await file.toBase64(person.power.originFileObj || person.power);

          documents.push({
            typeKey: DocumentTypeKey.AUTHORIZED_TO_GIVE_INSTRUCTION_POWER,
            base64,
            filename: person.power.name,
          });
        }

        return {
          ...person,
          documents,
          power: undefined,
          address: {
            ...person.address,
            streetNumber: Number(person.address.streetNumber),
            house: undefined,
          },
        };
      })
    );

    const payload = {
      ...values,
      mainLegalRepresentative: {
        ...values.mainLegalRepresentative,
        nif: Number(values.mainLegalRepresentative.nif) || undefined,
        foreignTaxResidences: values.mainLegalRepresentative.foreignTaxResidences || [],
      },
      authorizedToGiveInstructions,
      peopleWithForeignTaxResidence: values.peopleWithForeignTaxResidence || [],
      legalPerson: {
        ...values.legalPerson,
        rut: undefined,
        hasMoreThanHalfAsPassiveRent: !!values.legalPerson.hasMoreThanHalfAsPassiveRent,
        hasPeopleWithForeignTaxResidence: !!values.legalPerson.hasPeopleWithForeignTaxResidence,
      },
      deliverablesDestinataries: values.deliverablesDestinataries
        ? [
            ...Object.values(values.deliverablesDestinataries).reduce((items, item) => [
              ...items,
              ...item,
            ]),
          ]
        : [],
    };

    updateEnrollment(payload, onFinish);
  };

  return (
    <Spin spinning={isLoading}>
      <FormComplementaryInfo onFinish={handleSubmit} />
    </Spin>
  );
};

ComplementaryInfo.propTypes = {
  onFinish: PropTypes.func.isRequired,
};

export default ComplementaryInfo;
